<template>
  <div id="app">
    <div id="nav" ref="nav">
      <div class="box">
        <div class="welcome"><span>欢迎来到四川泰立智汇科技有限公司！</span></div>
        <div class="navBottom">
          <div class="logo">
            <img class="left" src="@/assets/LOGO.png" alt="" style="margin-right:10px;">
            <img class="right" src="@/assets/LOGOTEXT.png" alt="">
          </div>
          <div class="menu">
            <el-menu :router="true" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="/home">首页</el-menu-item>
              <el-menu-item index="/about">关于我们</el-menu-item>
              <el-submenu index="3">
                <template slot="title">服务与产品</template>
                <el-menu-item index="/serve" style="font-size:16px !important;font-family: PingFangSC, PingFangSC-Medium !important;">工程建设和服务</el-menu-item>
                <el-menu-item index="/product" style="font-size:16px !important;font-family: PingFangSC, PingFangSC-Medium !important;">软件系统和产品</el-menu-item>
                <el-menu-item index="/solution" style="font-size:16px !important;font-family: PingFangSC, PingFangSC-Medium !important;">应用场景解决方案</el-menu-item>
              </el-submenu>
              <el-menu-item index="/caseCenter">案例中心</el-menu-item>
              <el-menu-item index="/news">新闻中心</el-menu-item>
              <el-menu-item index="/contact">联系我们</el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="toTop" ref="toTop" v-show="toTopShow">
      <ul>
        <li style="border-bottom: 1px solid #cdcfda;" @click="backTop()">
          <p class="el-icon-upload2"></p>
          <p class="text">返回顶部</p>
        </li>
        <li style="border-bottom: 1px solid #cdcfda;">
          <p class="el-icon-circle-plus-outline"></p>
          <p class="text">关注我们</p>
          <div class="code"><img src="./assets/rightCode.png" alt=""></div>
        </li>
        <li>
          <p class="el-icon-phone-outline"></p>
          <p class="text">联系我们</p>
          <div class="infoList">
            <p class="contact"><span class="el-icon-phone-outline" style="margin-right:10px;"></span><span>028-87070807/028-87415137</span></p>
            <p class="contact"><span class="el-icon-message" style="margin-right:10px;"></span><span>china-tillage@china-tillage.com</span></p>
            <p class="contact"><span class="el-icon-location" style="margin-right:10px;"></span><span>成都市青羊工业集中发展区K区13栋(敬业路218号)</span></p>
          </div>
        </li>
      </ul>
    </div>
    <router-view/>
    <div class="footer">
      <div class="info">
        <img class="logo" src="./assets/bottomLogo.png" alt="">
        <ul>
          <li>
            <p class="title">邮箱</p>
            <p class="subTitle">china-tillage@china-tillage.com</p>
          </li>
          <li>
            <p class="title">电话</p>
            <p class="subTitle">028-87070807 028-87415137</p>
          </li>
          <li>
            <p class="title">地址</p>
            <p class="subTitle">中国·成都市青羊工业集中发展区K区13栋（敬业路218号）</p>
          </li>
        </ul>
        <div>
          <img src="./assets/QRcode.png" alt="">
          <p style="font-size: 12px;color: #ffffff;">请使用微信扫描二维码关注我们</p>
        </div>
      </div>
      <p class="bottom">四川泰立智汇科技有限公司 版权所有 @ 蜀ICP备19011495号-1</p>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'contact',
  data() {
    return {
      toTopShow: false,
      scrollTop:"",  // 滚动条距顶部的距离
      timer: null, // 回到顶部定时器
      // activeIndex: "/home",
    }
  },
  components: {},
  computed:{
    activeIndex(){
      let route = this.$route
      const { path } = route
      return path
    }
  },
  mounted() {
    window.addEventListener("scroll",this.getScollPosition,false)
  },
  methods: {
    // 监听滚动条的高度
    getScollPosition(){
      // console.log(e)
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let nav = this.$refs.nav
      if(this.scrollTop >=100){
        // console.log(nav)
        nav.style.background="#060e36";
      }else{
        nav.style.background="transparent";
      }
      if(this.scrollTop >= 600){
        this.toTopShow = true
      }else{
        this.toTopShow = false
      }
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this
      this.timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(this.timer)
        }
      }, 10)
    },
    handleSelect(){}
  },
}
</script>


<style lang="scss" scope>
*{
  margin: 0;
  padding: 0;
  list-style-type: none;
  font-family: PingFangSC, PingFangSC-Medium !important;
}
// logo旋转动画
@keyframes logoRotate {
  0%{transform: rotate(0deg);}
  100%{transform: rotate(360deg);}
}
@keyframes welcomeMove {
  // 0%{transform: translateX(0);}
  // 25%{transform: translateX(-50%);}
  // 50%{transform: translateX(-100%);}
  // 75%{transform: translateX(50%);}
  // 100%{transform: translateX(0);}
  0%{right: -204px;}
  100%{right: 100%;}
}


#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  width: 100%;
  height: 100px;
  // padding: 0 20%;
  position: fixed;
  z-index: 99;
  background-color: transparent;
  .box{
    width: 1200px;
    margin: 0 auto;
    .welcome{
      // width: 204px;
      height: 10px;
      font-size:12px;
      color:#ffffff;
      text-align:center;
      padding: 10px 0;
      position: relative;
      overflow: hidden;
      span{
        display: inline;
        width: 204px;
        position: absolute;
        right: -204px;
        animation: welcomeMove 20s linear infinite;
      }
    }
    .logo{
      // border: 1px solid red;
      position: relative; 
      top: 10px;
      .left{
        animation: logoRotate 15s linear infinite;
      }
      .right{
        position: absolute;
        top: 5px;
      }   
    }
    .navBottom{
      display: flex;
      justify-content: space-between;
    }
    .menu{
      width: 60%;
      height: 50px;
      padding-top: 10px;
      display: flex;
      justify-content: space-around;
      .el-menu-demo{
        li{
          font-size: 18px;
          
        }
      }
    }
  }
  
}

#nav a {
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  text-decoration: none;
  text-shadow: 0px 0px 6px 0px rgba(85, 85, 85, 0.5); 
}
// #nav .el-input__inner{
//   width: 120px;
//   height: 30px;
//   background: transparent;
//   border: none;
//   color: #ffffff;
//   font-size: 18px;
// }
// #nav a.router-link-exact-active {
//   color: #3488EA;
//   // border-bottom: 2px solid white;
// }

#app .footer{
  width: 60%;
  height: 432px;
  padding: 0 20%;
  opacity: 1;
  background: #060e36;
  .info{
    width: 100%;
    height: 80%;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    ul{
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      li{
        color: white;
        p.title{
          font-size: 18px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #ffffff;
          padding: 10px;
        }
        p.subTile{
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
    img{
      width: 130px;
      height: 130px;
      margin-top: 100px;
    }
    img.logo{
      width: 117px;
      height: 164px;
    }
  }
  p.bottom{
    padding-top: 20px;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #e5e5e5;
    border-top: 1px solid rgb(75, 74, 74);
  }
}
#app .toTop{
  width: 60px;
  height: 180px;
  position: fixed;
  top: 500px;
  right: 0px;
  z-index: 100;
  background: #ffffff;
  border: 1px solid #cdcfda;
  ul{
    width: 100%;
    height: 100%;
    li{
      width: 100%;
      height: 40px;
      padding: 10px 0;
      position: relative;
      cursor: pointer;
      p{
        padding: 1px 0;
      }
      p.text{
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Light;
        font-weight: 300;
        text-align: center;
        color: #1b2245;
        line-height: 20px;
      }
      .code{
        width:160px;
        height:160px;
        position:absolute;
        top:0px;
        left:-160px;
        display: none;
      }
      .infoList{
        width: 220px;
        height: 140px;
        position:absolute;
        top: 0px;
        left: -262px;
        background: #ffffff;
        padding: 20px;
        display: none;
        z-index: 101;
        p{
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Light;
          font-weight: 300;
          // color: #1b2245;
          // line-height: 20px;
          // text-align: left;
          padding: 8px 0;
          display: flex;
          justify-content: space-between;
          span{
            display: inline;
            height: 30px;
          }
        }
      }
    }
    li:hover{
      background: #3488ea;
      p{
        color: #fff;
      }
      .code{
        display: block;
      }
      .infoList{
        display: block;
        p.contact{
          color: #1b2245;
        }
      }
    }
  }
}

.el-menu{
  background: transparent !important;
}
.el-menu--horizontal>.el-menu-item{
  height: 50px !important;
}
.el-menu.el-menu--horizontal{
  border-bottom: none !important;
}
.el-menu--horizontal>.el-menu-item.is-active{
  color: #409EFF !important;
  border-bottom: 0px !important;
}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, 
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, 
.el-menu--horizontal>.el-submenu .el-submenu__title:hover{
  background: transparent !important;
  font-size: 18px !important;
  color: #fff !important;
  font-family: PingFangSC, PingFangSC-Medium;
}
.el-menu-item{
  font-family: PingFangSC, PingFangSC-Medium;
  font-size: 18px !important;
  color: #fff !important;
  border-bottom: 0px !important;
}
.el-menu--horizontal>.el-submenu .el-submenu__title{
  height: 50px !important;
  font-size: 18px !important;
  color: #fff !important;
  font-family: PingFangSC, PingFangSC-Medium;
}
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
  background-color: rgb(6, 14, 54) !important;
  font-size: 18px !important;
  color: #fff !important;
  font-family: PingFangSC, PingFangSC-Medium;
}
</style>
